
import styled from 'styled-components'

import COLORS from 'constants/colors'
import LAYOUT from 'constants/layout'
import MEDIA from 'constants/media'


const FeaturedNewsWrap = styled.div`
  background-color: ${COLORS.LIGHTYELLOW};
  padding: ${LAYOUT.VERTICALSPACEMOBILE} 20px;
  margin: auto;
  text-align: center;
  ${MEDIA.medium`
    padding: ${LAYOUT.VERTICALSPACE} 20px;
  `}
`

export default FeaturedNewsWrap
